import React from 'react';
import Main from './Main';
import { ICommonMyList } from '../Me/AllForMe';
// 注意，这个页面出现在2个地方，一个是MainTab，一个是在Me下
interface IAllForMyPhotos extends ICommonMyList {
  eventName: string;
}
const AllForMyPhotos = function(props: IAllForMyPhotos) {
  return (
    <Main
      loadMore={props.loadMore}
      refresh={props.refresh}
      eventName={props.eventName}
    />
  );
};

export default AllForMyPhotos;
